module.exports = __webpack_public_path__ + "img/icon-pinterest.261d0824.svg";